var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 290.498,
    cy: 216.037,
    r: 45.723,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.434 59.129 166.569.666a38.508 38.508 0 0 0-44.943 30.753l-16.172 86.27h-64.8A38.507 38.507 0 0 0 2.147 156.2v317.3A38.507 38.507 0 0 0 40.654 512h317.3a38.507 38.507 0 0 0 38.507-38.507v-28.551l9.321 1.748a38.507 38.507 0 0 0 44.943-30.753l58.464-311.865a38.508 38.508 0 0 0-30.755-44.943zm-451.4 275.457V171.3a28.728 28.728 0 0 1 28.728-28.728h288.855a26.955 26.955 0 0 1 26.955 26.955v244.338l-120.554-113-43.962 26.82-67.282-67.285zm455.235-221.993L437.25 352.744l-40.791-55.665V156.2a38.507 38.507 0 0 0-38.507-38.507H130.774l12.526-66.84a28.729 28.729 0 0 1 33.532-22.943l283.911 53.223a26.954 26.954 0 0 1 21.526 31.46z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.4cdb7aa52a5cce23206f679b66452a82.svg";
export { ForwardRef as ReactComponent };